export default "__VITE_ASSET__CzA7CNWc__"